export default "__VITE_ASSET__vyfxqJPy__"